import { Grow, Theme } from '@mui/material';
import { FC } from 'react';
import { makeStyles } from 'tss-react/mui';
import { ReactComponent as OxIcon } from '../../assets/icons/ox-built-in.svg';
import ConnectorsTooltip from '../../elements/ConnectorsTooltip/ConnectorsTooltip';
import {
  SupplyChainConnector,
  SupplyChainItemType,
} from '../supplychain-types';
import SupplyChainConnectorLogo from './SupplyChainConnectorLogo';

const SupplyChainConnectorsRenderer: FC<SupplyChainConnectorsRendererProps> = ({
  connectors = [],
  showCustomIcon,
  type,
}) => {
  const { classes, cx } = useStyles();

  return (
    <div
      className={cx(
        classes.supplyChainConnectors,
        type === SupplyChainItemType.Category && classes.tool,
      )}>
      <Grow in>
        <div className={classes.connectorsContainer}>
          {showCustomIcon && (
            <OxIcon style={{ width: '1.5rem', height: '1.5rem' }} />
          )}
          {!showCustomIcon &&
            connectors
              .slice(0, 3)
              .map(
                ({
                  name,
                  badgeIcon: BadgeIcon,
                  connectorStatus,
                  displayName,
                  isBuiltIn,
                  status,
                }) => {
                  return (
                    <ConnectorsTooltip
                      isBuiltIn={isBuiltIn}
                      displayName={displayName}
                      statusColor={connectorStatus.color}
                      title={connectorStatus.title}
                      key={name}>
                      <div
                        className={
                          type === SupplyChainItemType.Category
                            ? classes.connectorBg
                            : ''
                        }>
                        <SupplyChainConnectorLogo
                          name={name}
                          connectorIcon={BadgeIcon}
                          isBuiltIn={isBuiltIn}
                          status={status}
                        />
                      </div>
                    </ConnectorsTooltip>
                  );
                },
              )}
        </div>
      </Grow>
    </div>
  );
};

const useStyles = makeStyles()((theme: Theme) => ({
  supplyChainConnectors: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
  },
  tool: {
    paddingInlineStart: 20,
  },
  connectorsContainer: {
    gap: theme.spacing(1),
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    height: '100%',
  },
  connectorBg: {
    padding: theme.spacing(0.5),
  },
}));

interface SupplyChainConnectorsRendererProps {
  connectors?: SupplyChainConnector[];
  showCustomIcon: boolean;
  type: SupplyChainItemType;
}

export default SupplyChainConnectorsRenderer;
